[
    {
        "key": "1",
        "z": 1,
        "points": [
            {
                "x": 0,
                "y": 0
            },
            {
                "x": 6,
                "y": 0
            },
            {
                "x": 6,
                "y": 8
            },
            {
                "x": 0,
                "y": 8
            }
        ]
    }
]
